/* Carrinho vazio: sugere categorias em vez de deixar o cliente sem saída. */
(function () {
  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  pronto(function () {
    var vazio = document.querySelector('.mkct__empty');
    if (!vazio) return;

    var cats = [
      ['iPhone lacrado', '/collections/iphone-lacrado'],
      ['Celulares', '/collections/celulares'],
      ['Tablets', '/collections/tablets'],
      ['Perfumaria', '/collections/perfumaria'],
      ['Relógios', '/collections/relogios']
    ];

    var wrap = document.createElement('div');
    wrap.className = 'mk-chips';
    wrap.style.justifyContent = 'center';
    wrap.style.marginTop = '22px';
    cats.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'mk-chip';
      a.href = c[1];
      a.textContent = c[0];
      wrap.appendChild(a);
    });
    vazio.appendChild(wrap);
  });
})();
